import React from 'react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import dlv from 'dlv'

import { Box, Grid, Text, Link } from 'system'
import {
  Heading,
  Button,
  ButtonGroup,
  PrevNext,
  Subheading,
} from '../components'
import { ReactComponent as EyeIconSVG } from '../assets/icon-eye.svg'
import { ReactComponent as IconArrowDownSVG } from '../assets/icon-arrow-down.svg'

const ButtonLinks = ({ hasExamples, hasFields, ...props }) => (
  <ButtonGroup {...props}>
    {hasExamples && (
      <Button
        as={Link}
        href="#examples"
        iconSVG={EyeIconSVG}
        mb={[2, 0]}
        mr={[0, 2]}
      >
        View Examples
      </Button>
    )}
    {hasFields && (
      <Button
        as={Link}
        href="#fields"
        iconPosition="after"
        iconSVG={IconArrowDownSVG}
        colorScheme="white"
      >
        Jump to field descriptions
      </Button>
    )}
  </ButtonGroup>
)

export const DocumentBody = ({
  children,
  hasExamples,
  hasFields,
  parent,
  parentURL,
  summary,
  title,
  prev,
  next,
}) => {
  return (
    <Box
      id="main-content"
      width={1}
      maxWidth="small"
      mx="auto"
      css={`
        .gatsby-resp-image-link {
          margin: ${p => p.theme.space[4]} 0;
        }

        .gatsby-resp-image-image {
          opacity: 1 !important;
        }

        figcaption {
          margin-top: -${p => p.theme.space[2]};
          text-align: center;
          color: ${p => p.theme.colors.gray[40]};
        }
      `}
    >
      <Box mbScale="l">
        {parent && (
          <Subheading as="p" fontSizeScale="s" mbScale="t" color="purple.50">
            <Link href={parentURL}>{parent}</Link>
          </Subheading>
        )}
        {title && (
          <Heading as="h2" fontSizeScale="xxl" mbScale="t">
            {title}
          </Heading>
        )}
        {summary && (
          <Text
            as="p"
            fontSizeScale="l"
            color="slate.50"
            lineHeight="copyTight"
          >
            {summary}
          </Text>
        )}
        {(hasFields || hasExamples) && (
          <ButtonLinks
            hasFields={hasFields}
            hasExamples={hasExamples}
            mtScale="m"
          />
        )}
      </Box>
      <Text lineHeight="copy" fontSizeScale="m">
        {children && <MDXRenderer>{children}</MDXRenderer>}
      </Text>
      {(prev || next) && (
        <Grid gridTemplateColumns="1fr 1fr" gridColumnGap={2} mt={8}>
          {prev && (
            <PrevNext
              href={dlv(prev, 'slug')}
              direction="prev"
              label="Previous"
              group={dlv(prev, 'parent')}
            >
              {dlv(prev, 'title')}
            </PrevNext>
          )}
          {next && (
            <PrevNext
              href={dlv(next, 'slug')}
              gridColumn="2"
              label="Next"
              group={dlv(next, 'parent')}
            >
              {dlv(next, 'title')}
            </PrevNext>
          )}
        </Grid>
      )}
    </Box>
  )
}
